// THE FINGERPRINT OF A PIECE OF CMS TEXT [R-022]: FNV-1a (32-bit) over its UTF-8 bytes, trimmed, as
// 8 hex digits. A translation of Contentful content is filed under the fingerprint of the English
// it was made from, so an entry edited in the CMS simply finds no translation — and shows its new
// English — until scripts/translate.py --content runs again; it can never show a stale one.
// scripts/translate.py computes the same value in Python; the two must stay identical.
export const contentKey = (text) => {
  const bytes = new TextEncoder().encode(String(text).trim())
  let h = 0x811c9dc5
  for (let i = 0; i < bytes.length; i++) {
    h ^= bytes[i]
    h = Math.imul(h, 0x01000193) >>> 0
  }
  return h.toString(16).padStart(8, '0')
}
